import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Input,
  Heading,
  VStack,
  FormControl,
  FormLabel,
  useToast,
  Flex,
  Divider,
  useColorMode
} from '@chakra-ui/react';
import Navigation from '../components/Navigation';
import axios from '../utils/axiosConfig';

const AdminCreateUserPage = () => {
  const { colorMode } = useColorMode();
  const [formData, setFormData] = useState({ name: '', email: '', password: '', collectionName: '' });
  const [csvFile, setCsvFile] = useState(null);
  const toast = useToast();
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const response = await axios.get('/api/protected/checkIsAdmin');
        setIsAdmin(response.data.isAdmin);
      } catch (error) {
        console.error('Error checking session:', error);
        setIsAdmin(false);
      }
    };

    checkAuthentication();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      await axios.post('/api/admin/create-user', formData);
      toast({ title: 'User created successfully!', status: 'success' });
      // Clear form after successful submission
      setFormData({ name: '', email: '', password: '', collectionName: '' });
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to create user';
      toast({ title: errorMessage, status: 'error' });
    }
  };

  const handleCsvUpload = async () => {
    const formData = new FormData();
    formData.append('file', csvFile);

    try {
      await axios.post('/api/admin/upload-users', formData);
      toast({ title: 'Users uploaded successfully!', status: 'success' });
    } catch (error) {
      toast({ title: 'Failed to upload users', status: 'error' });
    }
  };

  return !isAdmin ? (<></>) : (
    <Flex>
      <Navigation />
      <Box p={8} flex="1">
        <Heading size="lg" mb={6} color={colorMode === 'light' ? 'gray.800' : 'white'}>Create User</Heading>
        <VStack spacing={4} align="stretch">
          <FormControl>
            <FormLabel color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Name</FormLabel>
            <Input
              name="name"
              placeholder="Enter user name"
              value={formData.name}
              onChange={handleInputChange}
            />
          </FormControl>

          <FormControl>
            <FormLabel color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Email</FormLabel>
            <Input
              name="email"
              type="email"
              placeholder="Enter user email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </FormControl>

          <FormControl>
            <FormLabel color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Collection Name</FormLabel>
            <Input
              name="collectionName"
              value={formData.collectionName}
              placeholder="Enter collection name"
              onChange={handleInputChange}
            />
          </FormControl>

          <Button colorScheme="teal" onClick={handleSubmit}>Create User + Collection</Button>
          <Divider my={6} />

          <FormControl>
            <FormLabel color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Upload CSV</FormLabel>
            <Input
              type="file"
              onChange={(e) => setCsvFile(e.target.files[0])}
            />
          </FormControl>
          <Button colorScheme="blue" onClick={handleCsvUpload}>Upload Users</Button>
        </VStack>
      </Box>
    </Flex>
  );
};

export default AdminCreateUserPage;
